/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, ContentChildren, forwardRef, Input, QueryList } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-ui-checkbox-group',
  templateUrl: './ui-checkbox-group.component.html',
  styleUrls: ['./ui-checkbox-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UICheckboxGroupComponent),
      multi: true
    }
  ],
  standalone: false
})
export class UICheckboxGroupComponent implements ControlValueAccessor {
  disabled: boolean;
  values: (string | number)[] = [];

  @Input() errorMessage = '';
  @Input() label = '';
  @Input() tooltipText = '';
  @Input() hasError = false;
  @Input() selectionOrder = false;

  @ContentChildren('app-ui-checkbox-group-item') uiCheckboxItems: QueryList<{ value: string | number }>;

  onChange = (values: (string | number)[]) => {};
  onTouch = () => {};

  constructor() {}

  registerOnChange(fn: (values: (string | number)[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(values: null | string[] | number[]): void {
    if (values === null) {
      return;
    }
    this.values = values;
  }

  onCheckboxChange(value: string | number) {
    const index = this.values.indexOf(value);

    if (index > -1) {
      this.values = [...this.values.slice(0, index), ...this.values.slice(index + 1)];
    } else {
      this.values = [...this.values, value];
      if (this.selectionOrder) {
        // order selection result
        const checkboxesOrderedValues: (string | number)[] = this.uiCheckboxItems.map((item) => {
          return item.value;
        });
        this.values = this.values.slice().sort((a, b) => checkboxesOrderedValues.indexOf(a) - checkboxesOrderedValues.indexOf(b));
      }
    }
    this.onChange(this.values);
    this.onTouch();
  }

  isChecked(value: string | number) {
    return this.values.includes(value);
  }
}
